module.exports = __webpack_public_path__ + "img/group.5b617650.svg";